import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import {
  getArtToneClass,
  getExperienceDisplayName,
  getHomeDateLine,
  getHomeMetaItems,
  getHomeTypeLine,
  getScenarioBadge,
} from './homeExperienceData'

/**
 * v7 `.experience-home-card` — the artwork band with status chip and place,
 * then type, name, dates and the meta footer.
 */
const ExperienceHomeCard = ({ quest, scenario, index = 0, onOpen }) => {
  const badge = getScenarioBadge(scenario)
  const name = getExperienceDisplayName(quest)
  const dateLine = getHomeDateLine(quest, scenario)
  const metaItems = getHomeMetaItems(quest)
  const isDraft = scenario === 'draft' || scenario === 'new'

  return (
    <article
      className='experience-home-card'
      role='button'
      tabIndex={0}
      aria-label={`Open ${name}`}
      onClick={onOpen}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          if (onOpen) {
            onOpen()
          }
        }
      }}>
      <div
        className={classNames('experience-home-art', getArtToneClass(index))}>
        <span className={`badge-experience ${badge.className}`}>
          {badge.label}
        </span>
        {quest?.location ? (
          <span className='experience-home-place'>{quest.location}</span>
        ) : null}
      </div>
      <div className='experience-home-body'>
        <span className='experience-home-type'>
          {getHomeTypeLine(quest, scenario)}
        </span>
        <h3>{name}</h3>
        {dateLine ? (
          <div className='experience-home-date'>{dateLine}</div>
        ) : null}
        {metaItems.length > 0 ? (
          <div className='experience-home-meta'>
            {metaItems.map((item) => (
              <span
                key={item.key}
                className={item.warn ? 'warn-txt' : undefined}>
                <b>{item.value}</b> {item.label}
              </span>
            ))}
          </div>
        ) : null}
        <div className='experience-home-open'>
          {isDraft ? 'Continue setup' : 'Open experience'}
          <span aria-hidden='true'>→</span>
        </div>
      </div>
    </article>
  )
}

ExperienceHomeCard.propTypes = {
  quest: PropTypes.object.isRequired,
  scenario: PropTypes.string.isRequired,
  index: PropTypes.number,
  onOpen: PropTypes.func,
}

export default ExperienceHomeCard
